import React, { Component } from "react";

export class PaymentDetail extends Component {
  renderField = (label, value) => (
    <div className="t-memberInfo-summaryItem">
      <span className="t-memberInfo-summaryLabel">{label}</span>
      <span className="t-memberInfo-summaryValue">{value ?? "-"}</span>
    </div>
  );

  render() {
    const { detail } = this.props;
    const isPayforPayment = detail?.isPayforPayment === 2;

    return (
      <div className="t-memberInfo-cardSummary t-listPayments-detailGrid">
        {this.renderField("Durumu", detail?.statusMessage)}
        {this.renderField("Org. Ücreti Talimat Tutarı", `${detail?.installmentAmount ?? "-"} ₺`)}
        {isPayforPayment &&
          this.renderField("Ödenen Toplam Tutar", `${detail?.totalAmount ?? "-"} ₺`)}
        {isPayforPayment && this.renderField("Taksit Sayısı", detail?.installmentCount)}
        {this.renderField("Başarılı Ödeme Sayısı", detail?.successPaymentCount)}
        {this.renderField("Başarısız Ödeme Sayısı", detail?.failPaymentCount)}
        {this.renderField("Beklenen Ödeme Sayısı", detail?.waitingPaymentCount)}
        {this.renderField("İşlemi Gerçekleştiren", detail?.createUser)}
        {this.renderField("Kart Adı", detail?.cardHolderName)}
        {this.renderField("Kredi Kartı Numarası", detail?.creditCardNumber)}
      </div>
    );
  }
}

export default PaymentDetail;
